import { render, staticRenderFns } from "./viewOfferDealsInquireList.vue?vue&type=template&id=77b67306&"
import script from "./viewOfferDealsInquireList.vue?vue&type=script&lang=js&"
export * from "./viewOfferDealsInquireList.vue?vue&type=script&lang=js&"
import style0 from "./viewOfferDealsInquireList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports